import TextInput from "../../../Inputs/CustomInputs/TextInput";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import PhoneInputWithoutVerification from "../../../Inputs/CustomInputs/PhoneInputWithoutVerification";
import { 
    getErrorMessage,
    isEmail,
    isPhoneNumber,
    isRequired
} from "../../../../../utils/FormUtils";
import { phoneNumberToSend } from "../../../../../utils/CommonUtils";
import Strings from "../../../../../resources/Strings";
import { INPUTS_PROPS } from "../../../../../enums/Enums";
import { useState, useEffect } from "react";
import classes from "../WizardForm.module.css";

const SearchUserStep = (props) => {
  const [errors, setErrors] = useState({});

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  useEffect(() => {
    const hasError = Object.values(errors).some((hasError) => hasError);
    props.handleCurrentStepValidity(hasError);
  }, [errors]);

  const handleFieldsChange = (newProp) => {
    // clear the untouched field
    // or update normally (case: dialingPhone & phoneNumber)
    let obj = {...newProp};

    if (Object.keys(newProp)[0] === "email") {
      obj = {...newProp, "phoneNumber" : ""};
    }
    if (Object.keys(newProp)[0] === "phoneNumber") {
      obj = {...newProp, "email" : ""};
    }
    
    props.handleChange(obj);
  };
  
  return (
    <>
        <div className={classes.validationTitle}>{Strings.SEARCH_USER_VALIDATE}</div>
        <div className={classes.stepContainer}>
            <TextInput
                label={Strings.INPUT_LABELS.EMAIL}
                id={INPUTS_PROPS.EMAIL}
                value={props.email}
                isStepSubmitted={props.isStepSubmitted}
                handleError={handleError} 
                onChange={handleFieldsChange}
                hasError={(props.email !== "" && props.phoneNumber === "") ? !isRequired(props.email).isValid || !isEmail(props.email).isValid : false}
                errorMessage={getErrorMessage(isRequired(props.email)) ? getErrorMessage(isRequired(props.email)) : getErrorMessage(isEmail(props.email))}
            />            
            <PhoneInputWithoutVerification
                label={Strings.INPUT_LABELS.PHONE_NUMBER}
                id={INPUTS_PROPS.PHONE_NUMBER}
                phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
                value={props.phoneNumber}
                isVerifyValidationNeeded={false}
                dialingCode={props.dialingCode}
                isPhoneVerified={props.isPhoneVerified}
                onChange={handleFieldsChange}
                handleError={handleError} 
                isStepSubmitted={props.isStepSubmitted}
                hasError={(props?.phoneNumber !== "" && props?.email === "") ? !isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid : false}
                errorMessage={getErrorMessage(isRequired(props.phoneNumber)) ? getErrorMessage(isRequired(props.phoneNumber)) : getErrorMessage(isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)))}
            />
            <div className={classes.buttonContainer}>
                <div>
                    <EllipseButton type="button" onClick={props?.searchUser} minWidth={'100px'}>{Strings.SEARCH}</EllipseButton>
                </div>
            </div>
            
        </div>
    </>
  )
}

export default SearchUserStep;